<template>
  <div>
    <settings-top-nav :selectedCustomKeyName="selectedCustomMetadataInfo.name"
      :componentname="selectedComponent"
      @changeToSelectedCustomMetadataTableComponent='changeToSelectedCustomMetadataComponent'
      :showAddCustomKeyButton="selectedComponent != 'add-custom-metadata'">
    </settings-top-nav>
    <component :is="selectedComponent" v-bind="currentProperties"
    :page="page" :searchFilters="searchFilters"
    @pageSwitched="handlePaginationSwitch" @searchFiltersUpdated="handleSearchFilters"
    :selectedCustomKeyName="selectedCustomMetadataInfo.name"
      @changeToSelectedCustomMetadataTableComponent='changeToSelectedCustomMetadataComponent'
    @changeToSelectedCustomKeyComponent='changeToSelectedCustomMetadataComponent' class="h-100"></component>
  </div>
</template>

<script>

import AddCustomMetadata from "./AddCustomMetadata.vue"
import ShowCustomMetadatas from "./ShowCustomMetadatas.vue"
import CustomMetadataInfo from "./CustomMetadataInfo.vue"
import settingsTopNav from "./HeaderBar.vue"

export default {
  name: "CustomMetadatas",
  data() {
    return {
      selectedComponent: ShowCustomMetadatas,
      selectedCustomMetadataInfo: {},
      page:1,
      searchFilters:{
        type:'all',
        label: 'All'
      }
    };
  },
  provide() {
    return {
      changeSelectedComponent: this.changeSelectedComponent,
    };
  },
  components: {
    "add-custom-metadata": AddCustomMetadata,
    "custom-metadata-info": CustomMetadataInfo,
    "show-custom-metadatas": ShowCustomMetadatas,
    "settings-top-nav": settingsTopNav,
  },
  methods: {
    handlePaginationSwitch(pageNo){
      this.page = pageNo
    },
    handleSearchFilters(searchfilterVals){
      this.searchFilters = searchfilterVals;
    },
    changeToSelectedCustomMetadataComponent(compName, customMetadataDetails) {
      this.selectedComponent = compName;
      this.selectedCustomMetadataInfo = customMetadataDetails
    },
    showBinsTopNav() {
      let comps = [
        "add-custom-metadata",
        "custom-metadata-info"
      ];
      if (comps.indexOf(this.selectedComponent) > -1) {
        return true;
      }
    }
  },
  computed:{
      currentProperties() {
      if (this.selectedComponent === "custom-metadata-info") {
        return { selectedCustomMetadataId : this.selectedCustomMetadataInfo._id};
      }
      else{
          return {}
      }
    },
  }
};
</script>

<style scoped>

</style>